import { Box, Link, Typography } from '@mui/material';
import './TelegramGroupsHelp.css';

const WHATSAPP_TELEGRAM_HELP = `https://wa.me/5491161297377?text=${encodeURIComponent(
  'Necesito ayuda con mi grupo de telegram.'
)}`;

const WHATSAPP_LINK_LABEL = 'WhatsApp al +5491161297377';

const TELEGRAM_SUPPORT_URL = 'https://telegram.org/support?setln=es';

const ContactLine = () => (
  <Typography variant="body1" className="telegramGroupsHelpBody">
    En caso de que el problema persista por favor comunícate con nosotros por{' '}
    <Link href={WHATSAPP_TELEGRAM_HELP} target="_blank" rel="noopener noreferrer" underline="hover">
      {WHATSAPP_LINK_LABEL}
    </Link>{' '}
    para poder ayudarte personalmente o brindarte una solución alternativa.
  </Typography>
);

interface SectionProps {
  title: string;
  children: React.ReactNode;
}

const Section = ({ title, children }: SectionProps) => (
  <Box className="telegramGroupsHelpSection">
    <Typography
      component="h2"
      variant="subtitle1"
      className="telegramGroupsHelpHeading"
      fontWeight={700}>
      {title}
    </Typography>
    {children}
  </Box>
);

const TelegramGroupsHelp = () => {
  return (
    <Box className="telegramGroupsHelp">
      <Section title="¿No te llega el código de verificación?">
        <Typography variant="body1" className="telegramGroupsHelpBody">
          Probá estas formas de resolverlo sugeridas por Telegram:
        </Typography>
        <ol className="telegramGroupsHelpList">
          <li>
            Asegurate estar escribiendo tu número correctamente y que comience con{' '}
            <strong>+54 9</strong>
          </li>
          <li>
            No hagas un intento tras otro. Si ya lo intentaste una vez dejá pasar un tiempo, lo más
            recomendable son 24 horas, pero en caso de que no puedas esperar tanto te recomendamos
            esperar al menos 1 hora y volver a intentar.
          </li>
          <li>
            Si lo anterior no funciona, otra opción es desinstalar la aplicación y volverla a
            instalar.
          </li>
          <li>
            Como última opción podés completar el{' '}
            <Link
              href={TELEGRAM_SUPPORT_URL}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover">
              formulario de ayuda oficial de Telegram
            </Link>
            .
          </li>
        </ol>
        <ContactLine />
      </Section>

      <Section title="¿Telegram te pide pagar para enviarte un SMS de verificación?">
        <Typography variant="body1" className="telegramGroupsHelpBody">
          Telegram es una app 100% gratuita pero en algunas ocasiones pide pagar el SMS de
          verificación, no ocurre siempre, solo si por alguna razón detecta algo sospechoso con tu
          número, por ejemplo, que tu número es un número reciclado.
        </Typography>
        <Typography variant="body1" className="telegramGroupsHelpBody">
          Para poder evitar pagar te damos las siguientes recomendaciones:
        </Typography>
        <ol className="telegramGroupsHelpList">
          <li>
            Si estás usando Wifi, desconéctalo, cambiá a Datos Móviles y volvé a intentar. O al
            revés, si estás usando Datos Móviles, desconéctalos, cambiá a Wifi y volvé a intentar.
          </li>
          <li>
            Si lo anterior no funciona, otra opción es desinstalar la aplicación y volverla a
            instalar.
          </li>
          <li>
            No hagas un intento tras otro. Si ya lo intentaste una vez dejá pasar un tiempo, lo más
            recomendable son 24 horas, pero en caso de que no puedas esperar tanto te recomendamos
            esperar al menos 1 hora y volver a intentar.
          </li>
          <li>
            Como última opción podés completar el{' '}
            <Link
              href={TELEGRAM_SUPPORT_URL}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover">
              formulario de ayuda oficial de Telegram
            </Link>
            .
          </li>
        </ol>
        <ContactLine />
      </Section>

      <Section title='"Toco mi Grupo para entrar al chat pero no sucede nada"'>
        <Typography variant="body1" className="telegramGroupsHelpBody">
          Para resolverlo abrí Telegram Web siguiendo estos pasos:
        </Typography>
        <ol className="telegramGroupsHelpList">
          <li>Abrí Telegram en tu computadora a través de Google o tu buscador favorito.</li>
          <li>Tocá la opción "Iniciá sesión con código QR".</li>
          <li>Ahora abrí la app de Telegram desde tu celular y andá a "Ajustes".</li>
          <li>Andá a "Dispositivos".</li>
          <li>
            Dale clic a "Vincular un dispositivo" para escanear el código QR que aparece en tu
            computadora.
          </li>
        </ol>
        <Typography variant="body1" className="telegramGroupsHelpBody">
          Después de haber iniciado sesión en Telegram Web vas a poder entrar a tu Grupo y también
          se te "destrabará" en tu celular para volver a usarlo desde ahí. O si lo preferís, podés
          continuar desde la computadora.
        </Typography>
        <ContactLine />
      </Section>
    </Box>
  );
};

export default TelegramGroupsHelp;
